import axios from "axios";
import { SuperAdminURL, MasterDataURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization`;

//  * FIND ORGANIZATION REPORT
export function findRecapitulationReport(queryParams) {
  return axios.post(`${URL}/find_recapitulation_report`, queryParams);
}

export const exportRecapitulation = payload => {
  // return axios.post(`${URL}/export_organization`, payload);
  return axios({
    url: `${URL}/export_recapitulation`,
    method: "POST",
    data: payload,
    responseType: "blob"
  });
};

// Get Program All
export function getProgram(queryParams) {
    return axios.post(`${URL}/program_list`, queryParams);
}

export function getProject(queryParams) {
  return axios.post(`${URL}/project_list`, queryParams);
}